// ============================================================
// FYUNOR — US Financial Constants
// Single source of truth for tax year, filing statuses, payroll
// frequencies, and default assumptions shared across US calculators.
// ============================================================

// --- Tax Year ---
export const TAX_YEAR = 2026;
export const TAX_DATA_VERSION = "2026.1";

// --- Currency & Locale ---
export const CURRENCY = "USD";
export const CURRENCY_SYMBOL = "$";
export const US_LOCALE = "en-US";

// --- 401(k) employee contribution limit (2026) ---
export const K401_LIMIT = 24500;

// --- Filing Status ---
export const FILING_STATUS = {
  SINGLE: "single",
  MARRIED_JOINTLY: "marriedJointly",
  MARRIED_SEPARATELY: "marriedSeparately",
  HEAD_OF_HOUSEHOLD: "headOfHousehold",
};

export const FILING_STATUS_OPTIONS = [
  { label: "Single", value: "single" },
  { label: "Married filing jointly", value: "marriedJointly" },
  { label: "Married filing separately", value: "marriedSeparately" },
  { label: "Head of household", value: "headOfHousehold" },
];

// --- Payroll Frequencies ---
export const PAYROLL_FREQUENCY = {
  ANNUALLY: "annually",
  MONTHLY: "monthly",
  SEMI_MONTHLY: "semi-monthly",
  BI_WEEKLY: "bi-weekly",
  WEEKLY: "weekly",
  DAILY: "daily",
  HOURLY: "hourly",
};

export const PAYROLL_FREQUENCY_OPTIONS = [
  { label: "Annually", value: "annually" },
  { label: "Monthly", value: "monthly" },
  { label: "Semi-monthly", value: "semi-monthly" },
  { label: "Bi-weekly", value: "bi-weekly" },
  { label: "Weekly", value: "weekly" },
  { label: "Daily", value: "daily" },
  { label: "Hourly", value: "hourly" },
];

// Periods per year for each payroll frequency.
export const PERIODS_PER_YEAR = {
  annually: 1,
  monthly: 12,
  "semi-monthly": 24,
  "bi-weekly": 26,
  weekly: 52,
  daily: 260,
  hourly: 2080,
};

// --- Default Assumptions ---
export const DEFAULTS = {
  HOURS_PER_WEEK: 40,
  WEEKS_PER_YEAR: 52,
  WORK_DAYS_PER_YEAR: 260,
  ANNUAL_HOURS: 2080,
};